export const CustomEllipsis = {
  minWidth: '10px'
} as const
